import { Injectable } from "@angular/core";
import { HttpInterceptor, HttpRequest, HttpHandler, HttpEvent } from "@angular/common/http";
import { AlertController, ToastController } from "@ionic/angular";
import { Network } from "@ionic-native/network/ngx";
import { catchError, map, timeout } from "rxjs/operators";
import { Observable, throwError } from "rxjs";
import { Router } from "@angular/router";
import { AdminService } from "../admin.service";

@Injectable()
export class RequestInterceptor implements HttpInterceptor {
  constructor(
    public toastController: ToastController,
    private network: Network,
    private router: Router,
    private adminService: AdminService,
    private alertController: AlertController
  ) { }

  intercept(
    request: HttpRequest<any>,
    next: HttpHandler
  ): Observable<HttpEvent<any>> {
    this.network.onConnect().subscribe(async () => {
      const toast = await this.toastController.create({
        message: "Back to Online",
        position: "top",
        duration: 3000,
        color: "success",
      });
      toast.present();
    });

    this.network.onDisconnect().subscribe(async () => {
      const toast = await this.toastController.create({
        message: "You are offline Please check Internet connection",
        position: "top",
        duration: 4000,
        color: "danger",
      });
      toast.present();
    });
   if (request.url.includes("AgentLead/AddLead")) {
      request = request.clone({
        setHeaders: {},
      });
      return next.handle(request).pipe(
        map((event: HttpEvent<any>) => {
          return event;
        })
      );
    } else {
      if (localStorage.getItem("tk_n") == null) {
        request = request.clone({
          setHeaders: {
            // 'Access-Control-Allow-Credentials': 'true',
            // 'Access-Control-Allow-Headers': 'Content-Type',
            //  "Content-type": "application/json"
            // Authorization: "bearer " + localStorage.getItem("token")
            // Athorization:
            // "bearer Al0mBuP7l-af3fuyKbADdnwc-VIn5-97UuR3ixoAioDAHJtFoCeUs3W5E2JNeCvpQ2UOL-QnSZFoRAfMuDFFl5xPncBU0LnjfRAQVR-ay2HUTcU7SE8oB_WGNExoyRu1e2aIaNihK8SX_omlY-G9ilSUGW4p6jCbwtKYJsq_A4A7YUbQGQWj0e94kUTD7z-EDewD45-nhaY9ZpWsz_lfu9lO04mwGxuRuVkoIuUTeBOaPbha6wYWMi4t7HERy8g6usOo6J6wYjQ_z2PnPToTFePKMJg8wBO6FUZY9h2GTMRgsm39AFEiIEj97XObqkWcg6AlvzDUB8ISnCRlKT-XWgN3xkl3tuMDBL0n6DEH8aNvP-HB9u8niYA7DHmEGPX7FLeu5CPhZbezgFfAjpsqgA",
            // Token:"tokenforvideoapp",
            // 'Access-Control-Allow-Origin': '*',
          },
        });
        return next.handle(request).pipe(

        );
      } else {
        request = request.clone({
          setHeaders: {
            Authorization: "bearer " + localStorage.getItem("tk_n"),
          },
        });

        return next.handle(request).pipe(
          catchError((error) => {

            return throwError(() => new Error("The Error"));
          })
        );
      }
    }
  }
  async presentAlert() {
    const alert = await this.alertController.create({
      header: "Expired!!!",
      subHeader: "Session Expired",
      message: "Please relogin with your credentials..",
      buttons: ["OK"],
    });

    await alert.present();
  }
}
